import { render } from "./ViewSeeTournamets.vue?vue&type=template&id=7b032239&scoped=true"
import script from "./ViewSeeTournamets.vue?vue&type=script&lang=js"
export * from "./ViewSeeTournamets.vue?vue&type=script&lang=js"

import "./ViewSeeTournamets.vue?vue&type=style&index=0&id=7b032239&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b032239"]])

export default __exports__